export const converteLevel = (level) => {
  if (!level) {
    return '';
  } else if (level < 6) {
    return 'Elementary';
  } else if (level < 9) {
    return 'Intermediate';
  } else if (level < 13) {
    return 'High';
  } else {
    return 'Professional';
  }
};
